import { render, staticRenderFns } from "./BotaoEnviarAnexos.vue?vue&type=template&id=5ad95aa2&scoped=true"
import script from "./BotaoEnviarAnexos.vue?vue&type=script&lang=js"
export * from "./BotaoEnviarAnexos.vue?vue&type=script&lang=js"
import style0 from "./BotaoEnviarAnexos.vue?vue&type=style&index=0&id=5ad95aa2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad95aa2",
  null
  
)

export default component.exports